import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-3" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex items-center h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium truncate mr-5" }, " Pengaturan Affiliate ", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_8 = { class: "col-span-12 grid grid-cols-12 gap-3 mt-3 intro-y w-full" }
const _hoisted_9 = { class: "col-span-12 flex flex-col box p-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Kode", -1)
const _hoisted_11 = { class: "flex flex-row items-center mt-2" }
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Pixel ID", -1)
const _hoisted_14 = { class: "flex flex-row items-center mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600" }, "Untuk multiple ID pisahkan dengan tanda , (koma)", -1)
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Ga ID", -1)
const _hoisted_18 = { class: "flex flex-row items-center mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600" }, "Untuk multiple ID pisahkan dengan tanda , (koma)", -1)
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Tiktok ID", -1)
const _hoisted_22 = { class: "flex flex-row items-center mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600" }, "Untuk multiple ID pisahkan dengan tanda , (koma)", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 col-span-12 border-2 border-gray-400" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_CopyIcon = _resolveComponent("CopyIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_LoadingDiv = _resolveComponent("LoadingDiv")!
  const _component_DataPromo = _resolveComponent("DataPromo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData())),
                class: "button bg-theme-1 hover:bg-primary text-white flex"
              }, [
                _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
                _hoisted_7
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input w-full border",
                  placeholder: "Kode",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataPS.data.kode) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.dataPS.data.kode]
                ]),
                _createVNode(_component_Tippy, {
                  tag: "a",
                  href: "javascript:;",
                  class: "inline-block ml-3",
                  content: "Copy Text",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$gpf.copy(_ctx.dataPS.data.kode)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CopyIcon, { class: "w-8 h-8 cursor-pointer text-primary" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input w-full border",
                  placeholder: "Pixel ID",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataPS.data.pixelId) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.dataPS.data.pixelId]
                ]),
                _createVNode(_component_Tippy, {
                  tag: "a",
                  href: "javascript:;",
                  class: "inline-block ml-3",
                  content: "Copy Text",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$gpf.copy(_ctx.dataPS.data.pixelId)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CopyIcon, { class: "w-8 h-8 cursor-pointer text-primary" })
                  ]),
                  _: 1
                })
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input w-full border",
                  placeholder: "Ga ID",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataPS.data.gaId) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.dataPS.data.gaId]
                ]),
                _createVNode(_component_Tippy, {
                  tag: "a",
                  href: "javascript:;",
                  class: "inline-block ml-3",
                  content: "Copy Text",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$gpf.copy(_ctx.dataPS.data.gaId)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CopyIcon, { class: "w-8 h-8 cursor-pointer text-primary" })
                  ]),
                  _: 1
                })
              ]),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input w-full border",
                  placeholder: "Tiktok ID",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataPS.data.tiktokId) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.dataPS.data.tiktokId]
                ]),
                _createVNode(_component_Tippy, {
                  tag: "a",
                  href: "javascript:;",
                  class: "inline-block ml-3",
                  content: "Copy Text",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$gpf.copy(_ctx.dataPS.data.tiktokId)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CopyIcon, { class: "w-8 h-8 cursor-pointer text-primary" })
                  ]),
                  _: 1
                })
              ]),
              _hoisted_23
            ]),
            _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updatePSAff())),
              type: "button",
              class: "button bg-theme-1 text-white mt-5 w-24 ml-auto"
            }, " Update ")
          ])
        ]),
        _createVNode(_component_LoadingDiv, { id: "loadingPS" })
      ])
    ]),
    _hoisted_24,
    _createVNode(_component_DataPromo)
  ], 64))
}